import type { UserType } from '@form-factory/schema';
import type { StateCreator } from 'zustand';

import { queryClient } from '@/services/queryClient';

export type UserSlice = {
  jwt: string | null;
  user: null | UserType;
  setJwt: (jwt: string | null) => void;
  setUser: (user: UserType | null) => void;
  currentOrganizationId: string | null;
  setCurrentOrganizationId: (currentOrganizationId: string | null) => void;
  logout: () => void;
};

export const userSlice: StateCreator<UserSlice> = set => ({
  jwt: null,
  user: null,
  setJwt: jwt => set({ jwt }),
  setUser: user => set({ user }),
  currentOrganizationId: null,
  setCurrentOrganizationId: currentOrganizationId =>
    set({ currentOrganizationId }),
  logout: () => {
    // Clear the query cache
    queryClient.clear();

    // Clear the user state
    set({
      jwt: null,
      user: null,
      currentOrganizationId: null,
    });
  },
});
